import { isLoginExceptionState } from "@shared/plugins/loginException.plugin"
import {
  createCipherSession,
  decryptWithSession,
  encryptWithSession,
  isEncryptedPayload
} from "@shared/helpers/src/cryptoCommunication.helper"

let BASE_URL = ""

const defaultHeader = {
  method: "",
  url: "",
  headers: {},
  data: {}
}

let defaultConfig = JSON.parse(JSON.stringify(defaultHeader))

export function resetDefaultHeaders() {
  defaultConfig = JSON.parse(JSON.stringify(defaultHeader))
}

function mergeHeaders(headers) {
  return { ...defaultConfig.headers, ...headers }
}

async function getGeolocation() {
  return await navigator.geolocation.getCurrentPosition(
    position => {
      window.$vue.$store.commit("Core/setCurrentCoordinates", {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
        accuracy: position.coords.accuracy
      })
    },
    error => {
      console.error(error)
      window.$vue.$geolocationDenied = true
    },
    {
      timeout: 10000,
      maximumAge: 30000
    }
  )
}

async function handleGetGeolocation() {
  try {
    await getGeolocation()

    const position = window.$vue.$store.getters["Core/getCurrentCoordinates"]

    if (position && position.latitude) {
      const { latitude, longitude, accuracy } = position
      if (latitude !== null && longitude !== null && accuracy !== null) {
        defaultConfig.headers.coordinates = JSON.stringify({
          latitude,
          longitude,
          accuracy
        })
      }
    }
  } catch (error) {
    console.error("Erro ao buscar a localização:", error.message)
  }
}

function getAndSetDeviceData() {
  const UserDevice = {
    platform: navigator.platform,
    browserName: navigator.appName,
    browserVersion: navigator.appVersion,
    vendor: navigator.vendor
  }
  defaultConfig.headers["User-Device"] = JSON.stringify(UserDevice)
}

function getEnvRequireEncrypt() {
  return Boolean(process.env.VUE_APP_ENCRYPT_COMUNICATION) === true
}

function getConfigRequireEncrypt(config) {
  return !!config && (config?.encrypt === undefined || config?.encrypt === true)
}

function getHasToEncryptData(config) {
  const REQUEST_METHOD_HAS_DATA = config.method === "post" || config.method === "put"
  const CONFIG_REQUIRE_ENCRYPT = getConfigRequireEncrypt(config)

  return getEnvRequireEncrypt() && REQUEST_METHOD_HAS_DATA && CONFIG_REQUIRE_ENCRYPT
}

async function createHttp($http, store, baseApiUrl = '') {
  BASE_URL = baseApiUrl

  async function request(config = {}) {
    const locked = isLoginExceptionState(config.url)
    if (locked) return
    //TODO: Separar instancia VUE -> Biometria
    if (!config?.headers?.coordinates) {
      const is_safari =
        /(safari)/i.test(navigator.userAgent) &&
        !/(chrome)/i.test(navigator.userAgent)

      await new Promise(async resolve => {
        // aguarda resposta do prompt de geolocalização
        if (!is_safari) {
          const result = await navigator.permissions.query({
            name: "geolocation"
          })

          if (result.state !== "denied") {
            await handleGetGeolocation()
            getAndSetDeviceData()
            resolve()
          } else {
            console.error("geolocation denied")
            window.$vue.$geolocationDenied = true
            resolve()
          }
        } else {
          await handleGetGeolocation()
          getAndSetDeviceData()
          resolve()
        }
      })
    }

    const cipherSession = getEnvRequireEncrypt() ? await createCipherSession() : null

    config.headers = { ...config.headers, ...(cipherSession?.headers || {}) }

    config.headers = mergeHeaders(config.headers)

    if (cipherSession && getHasToEncryptData(config)) {
      if (!(config?.data instanceof FormData) && config?.data !== undefined) {
        config.data = await encryptWithSession(cipherSession, config.data)
      }
    }

    try {
      const { data } = await $http(config)

      if (cipherSession && isEncryptedPayload(data)) {
        return await decryptWithSession(cipherSession, data)
      }

      return data
    } catch (error) {
      const errorData = error?.response?.data

      if (cipherSession && isEncryptedPayload(errorData)) {
        const data = await decryptWithSession(cipherSession, errorData)

        throw { ...error, response: { ...error.response, data } }
      }

      throw error
    }
  }

  const $get = async ({
    endpoint,
    baseUrl,
    headers,
    params,
    responseType,
    encrypt,
    resetAccessTime,
    skipInterceptors = false
  }) => {
    return request({
      method: "get",
      url: `${baseUrl || BASE_URL}${endpoint}`,
      headers,
      responseType,
      params,
      encrypt,
      resetAccessTime,
      skipInterceptors
    })
  }

  const $post = async ({
    endpoint,
    baseUrl,
    data,
    headers,
    encrypt,
    skipInterceptors = false
  }) => {
    return request({
      method: "post",
      url: `${baseUrl || BASE_URL}${endpoint}`,
      data: data,
      headers,
      encrypt,
      skipInterceptors
    })
  }

  const $put = async ({
    endpoint,
    baseUrl,
    data,
    headers,
    encrypt,
    skipInterceptors = false
  }) => {
    return request({
      method: "put",
      url: `${baseUrl || BASE_URL}${endpoint}`,
      data: data,
      headers,
      encrypt,
      skipInterceptors
    })
  }

  const $delete = async ({
    endpoint,
    baseUrl,
    data,
    headers,
    encrypt,
    skipInterceptors = false
  }) => {
    return request({
      method: "delete",
      url: `${baseUrl || BASE_URL}${endpoint}`,
      data: data,
      headers,
      encrypt,
      skipInterceptors
    })
  }

  return {
    $get,
    $post,
    $put,
    $delete
  }
}

export default createHttp
